import { render } from "./PaiceMcpServer.vue?vue&type=template&id=53969059&scoped=true"
import script from "./PaiceMcpServer.vue?vue&type=script&lang=js"
export * from "./PaiceMcpServer.vue?vue&type=script&lang=js"

import "./PaiceMcpServer.vue?vue&type=style&index=0&id=53969059&scoped=true&lang=css"
import "./PaiceMcpServer.vue?vue&type=style&index=1&id=53969059&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53969059"]])

export default __exports__